import React from 'react';

import LightBulbSVG from './assets/light-bulb.svg';

export const LightBulb = () => (
  <img src={LightBulbSVG} alt="" />
);
